var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideocall1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9961 8.93348C21.9961 8.32748 21.9961 8.02448 21.8761 7.88448C21.8249 7.82449 21.7603 7.77746 21.6875 7.74722C21.6146 7.71698 21.5357 7.70439 21.4571 7.71048C21.2731 7.72448 21.0571 7.93948 20.6311 8.36748L16.9961 12.0025L20.6301 15.6365C21.0581 16.0645 21.2731 16.2795 21.4561 16.2935C21.5347 16.2996 21.6136 16.287 21.6865 16.2567C21.7593 16.2265 21.8239 16.1795 21.8751 16.1195C21.9951 15.9795 21.9951 15.6765 21.9951 15.0705L21.9961 8.93348Z",
    fill: "#003EBF",
    stroke: "#003EBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9958 9.80068C1.87614 8.73543 1.98768 7.6569 2.3228 6.63868C2.61042 6.07422 3.06934 5.6153 3.6338 5.32768C4.65202 4.99256 5.73055 4.88102 6.7958 5.00068H12.1958C13.2611 4.88102 14.3396 4.99256 15.3578 5.32768C15.9223 5.6153 16.3812 6.07422 16.6688 6.63868C17.0039 7.6569 17.1155 8.73543 16.9958 9.80068V14.2007C17.1155 15.2659 17.0039 16.3445 16.6688 17.3627C16.3812 17.9271 15.9223 18.3861 15.3578 18.6737C14.3396 19.0088 13.2611 19.1203 12.1958 19.0007H6.7958C5.73055 19.1203 4.65202 19.0088 3.6338 18.6737C3.06934 18.3861 2.61042 17.9271 2.3228 17.3627C1.98768 16.3445 1.87614 15.2659 1.9958 14.2007V9.80068Z",
    fill: "#003EBF",
    stroke: "#003EBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall1);
export default __webpack_public_path__ + "static/media/Video call 1.1732aa062052b821aecc15e7b7820ff3.svg";
export { ForwardRef as ReactComponent };